import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import jwt_decode from 'jwt-decode';
import paidStamp from '../../images/icon/paid.png';
import moment from 'moment';
import Moment from 'react-moment';
import { setPrintInvoice, setDefaultPrinterName, showPrintLoader } from '../../../features/Data/dataSlice';
import { showPrinterSettingModal } from '../../../features/Offcanvas/printerSettingModalSlice';
import PrintLoader from './PrintLoader';

const PrintBill = ({
    businessData,
    authToken,
    invoiceWithOrders,
    paymentStatus,
    printInvoice,
    setPrintInvoice,
    bluetoothStatus,
    defaultPrinterName,
    setDefaultPrinterName,
    showPrinterSettingModal,
    buildType,
    showPrintLoader
}) => {
    const [branchData, setBranchData] = useState(null)
    const [businessTempData, setBusinessTempData] = useState(null)
    useEffect(() => {
        const tokenData = jwt_decode(authToken)
        if (businessData) {
          businessData.map((value, key) => {
            value.Branches.map((v,k) => {
                if (value.ID === tokenData.userInfo.Business_ID && v.ID === tokenData.userInfo.DefaultLocationID) {
                    setBranchData(v)
                    setBusinessTempData(value)
                }
            })
          }) 
        }
    }, [businessData, authToken])

    function printBillIframe(branchData, businessTempData) {
        var iframe = document.getElementById('myIframe');
        var dynamicLogo = ''
        if (!businessTempData?.Logo) {
            dynamicLogo = 'https://res.cloudinary.com/dc2toznmc/image/upload/v1573291347/file_oprzr9.jpg'
        } else {
            dynamicLogo = businessTempData?.Logo
        }
        console.log(dynamicLogo)
        const tableBody = document.createElement('tbody');
        invoiceWithOrders?.itemArr.map((v, k) => {
            const tr1 = document.createElement('tr');
            tr1.innerHTML = `<td align="left" style="font-size: 10px;">${v.ItemTitle}</td>
                        <td align="left" style="font-size: 10px;">${v.quantity}</td>
                        <td align="left" style="font-size: 10px;">${v.MRP}</td>
                        <td align="right" style="font-size: 10px;">${parseInt(v.MRP) * v.quantity}</td>`
            tableBody.append(tr1)
        });
        const formattedDate = moment(invoiceWithOrders?.Orders[0].DateTime).format('DD/MM/YYYY')
        console.log(formattedDate)
        const formattedTime = moment(invoiceWithOrders?.Orders[0].DateTime).format('HH:mm A')
        console.log(formattedTime)
        const PrintInvoiceReceipt = '<div id="printInvoiceReceipt"><div><font face="verdana" size="2"><div><div id="receiptDetails" style="page-break-after: always;"><div style="text-align: center; margin: 10px 0px 10px 0px";}}><img height="60px" src=' + dynamicLogo + ' /></div><div style=" font-weight: bold; text-align: center; word-wrap: break-word;">' + businessTempData?.Name + '</div><div style="text-align: center; word-wrap: break-word;">' + branchData?.Name + '</div><div style="text-align: center; font-size: 12px;">Bill No - ' + invoiceWithOrders?.billNo + '</div><div style="text-align: center; font-size: 12px;">' + invoiceWithOrders?.OrderType + '</div><div style="text-align: center; font-size: 12px;"><Moment format="DD-MM-YYYY HH:mm">' + invoiceWithOrders?.Orders[0].DateTime + '</Moment></div><hr /><table style="width: 100%;"><thead><tr><th align="left" style="font-size: 12px;"> ITEM </th><th align="left" style="font-size: 12px;"> QTY </th><th align="left" style="font-size: 12px;"> RATE </th><th align="right" style="font-size: 12px;"> PRICE </th></tr></thead>' + tableBody.innerHTML + '</table><hr /><div style="position: relative;"><table style="width: 100%;"><tbody><tr><td align="left" style="font-size: 10px;">Subtotal </td><td align="right" style="font-size: 10px;">' + invoiceWithOrders?.Subtotal + '</td></tr><tr><td align="left" style="font-size: 10px;">Discount (' + invoiceWithOrders?.DiscountType + ') </td><td align="right" style="font-size: 10px;">' + invoiceWithOrders?.TotalDiscount + '</td></tr><tr><td align="left" style="font-size: 10px;">Tax (0%) </td><td align="right" style="font-size: 10px;">0</td></tr><tr><td align="left" style="font-weight: 600; font-size: 10px;">Grand Total</td><td align="right" style="font-weight: 600; font-size: 10px;">' + invoiceWithOrders?.GrandTotal + '</td></tr></tbody></table></div><hr /><div style="text-align: center; margin-top: 15px; margin-bottom: 15px; word-wrap: break-word;">Thank You. Visit Again.</div><hr /><div align="center" style="font-size: 10px;">Powered by <b>allpos.com</b></div><br /></div></div></font></div></div>';
        
        if (buildType === 'webapk') {
            iframe.contentWindow.document.body.innerHTML = PrintInvoiceReceipt
    
    
            iframe.onload = function() {
                iframe.contentWindow.print();
            };
    
            if (iframe.contentDocument.readyState === 'complete') {
                iframe.contentWindow.print();
                showPrintLoader({printLoader: false})
            }
        } else {
            let checkPrinterConnection = null
                
            var plainText = extractTextFromHTML(PrintInvoiceReceipt);
            console.log(bluetoothStatus, defaultPrinterName)
            if (bluetoothStatus && defaultPrinterName) {
                window.BTPrinter.connect(function(data){
                    console.log("Connect Success", data);
                    // window.BTPrinter.printTextSizeAlign(function(data1){
                    //     console.log("printTextSizeAlign Success", data1);
                    //     window.BTPrinter.disconnect(function(data){
                    //         console.log("Success");
                    //         console.log(data)
                    //         showPrintLoader({printLoader: false})
                    //     },function(err){
                    //         console.log("Error");
                    //         console.log(err)
                    //         showPrintLoader({printLoader: false})
                    //     }, defaultPrinterName);
                    // },function(err){
                    //     window.BTPrinter.disconnect(function(data){
                    //         console.log("Success");
                    //         console.log(data)
                    //         showPrintLoader({printLoader: false})
                    //     },function(err){
                    //         console.log("Error");
                    //         console.log(err)
                    //         showPrintLoader({printLoader: false})
                    //     }, defaultPrinterName);
                    //     console.log("Error");
                    //     console.log(err)
                    //     showPrintLoader({printLoader: false})
                    // }, plainText,'0','0')
                    // Print the full receipt for a 58mm thermal printer
                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line for 58mm paper

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `${businessTempData?.Name}`, '1', '1'); // Store name, larger size and centered

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `${branchData?.Name}`, '0', '1'); // Address, normal size and centered

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Bill No #: ${invoiceWithOrders?.billNo}`, '0', '1'); // Phone number, normal size and centered

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Date: ${formattedDate}`, '0', '0'); // Date, left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Time: ${formattedTime}`, '0', '0'); // Time, left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "Item     Qty  Price  Total", '0', '0'); // Column headers, left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    invoiceWithOrders?.itemArr.map((v, k) => {
                        window.BTPrinter.printTextSizeAlign(function(data) {
                            console.log("Success");
                            console.log(data);
                        }, function(err) {
                            console.log("Error");
                            console.log(err);
                        }, `${v.ItemTitle}`, '0', '0'); // Product A details, left-aligned
                        window.BTPrinter.printTextSizeAlign(function(data) {
                            console.log("Success");
                            console.log(data);
                        }, function(err) {
                            console.log("Error");
                            console.log(err);
                        }, `         ${v.quantity}     ${v.MRP}       ${parseInt(v.MRP) * v.quantity}`, '0', '0'); // Product A details, left-aligned
                    })

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Subtotal              ${invoiceWithOrders?.Subtotal}`, '0', '0'); // Subtotal, left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "Tax Inclusive", '0', '0'); // Tax, left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Total                 ${invoiceWithOrders?.GrandTotal}`, '1', '0'); // Total, larger size and left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Payment Method: ${invoiceWithOrders?.OrderType}`, '0', '0'); // Payment method, left-aligned

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "-----------------------------", '0', '1'); // Shorter divider line

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, "Thank you!", '0', '1'); // Thank you message, centered

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                    }, `Visit us again at ${businessTempData?.Name}`, '0', '1'); // Visit message, centered

                    window.BTPrinter.printTextSizeAlign(function(data) {
                        console.log("Success");
                        console.log(data);
                        showPrintLoader({printLoader: false})
                    }, function(err) {
                        console.log("Error");
                        console.log(err);
                        showPrintLoader({printLoader: false})
                    }, "-----------------------------", '0', '1'); // Final divider line

                    window.BTPrinter.disconnect(function(data){
                        console.log("Success");
                        console.log(data)
                    },function(err){
                        console.log("Error");
                        console.log(err)
                    }, defaultPrinterName);

                },function(err){
                    window.BTPrinter.disconnect(function(data){
                        console.log("Success");
                        console.log(data)
                    },function(err){
                        console.log("Error");
                        console.log(err)
                    }, defaultPrinterName);
                    console.log("Error");
                    console.log(err)
                    setDefaultPrinterName({defaultPrinterName: null})
                    showPrintLoader({printLoader: false})
                    // localStorage.removeItem('defaultPrinterName')
                    showPrinterSettingModal({printerSettingModalVisible: true})
                }, defaultPrinterName);
            } else {
                showPrintLoader({printLoader: false})
                if (!bluetoothStatus) {
                    alert('Your bluetooth is off')
                } else if (bluetoothStatus && (!defaultPrinterName)) {
                    showPrinterSettingModal({printerSettingModalVisible: true})
                }
            }
        }
    }

    // function extractTextFromHTML(htmlString) {
    //     // Create a temporary DOM element
    //     var tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = htmlString;
      
    //     // Find the table
    //     var table = tempDiv.querySelector('table');
    //     if (!table) {
    //       console.error('No table found in the HTML string');
    //       return '';
    //     }
      
    //     // Extract table data row by row
    //     var rows = table.rows;
    //     var output = '';
      
    //     for (var i = 0; i < rows.length; i++) {
    //       var cells = rows[i].cells;
    //       for (var j = 0; j < cells.length; j++) {
    //         output += cells[j].textContent.trim() + '\t'; // Use tab for spacing between columns
    //       }
    //       output += '\n'; // New line for each row
    //     }
      
    //     return output;
    // }

    function extractTextFromHTML(htmlString) {
        // Create a temporary DOM element
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
    
        // Extract all text content
        var output = '';
    
        // Extract business name, branch name, and invoice details
        var businessName = tempDiv.querySelector('#receiptDetails > div:nth-child(2)');
        var branchName = tempDiv.querySelector('#receiptDetails > div:nth-child(3)');
        var billNo = tempDiv.querySelector('#receiptDetails > div:nth-child(4)');
        var orderType = tempDiv.querySelector('#receiptDetails > div:nth-child(5)');
        var orderDate = tempDiv.querySelector('#receiptDetails > div:nth-child(6)');
    
        output += (businessName ? businessName.textContent.trim() : '') + '\n';
        output += (branchName ? branchName.textContent.trim() : '') + '\n';
        output += (billNo ? billNo.textContent.trim() : '') + '\n';
        output += (orderType ? orderType.textContent.trim() : '') + '\n';
        output += (orderDate ? orderDate.textContent.trim() : '') + '\n\n';
    
        // Find the table and extract data
        var table = tempDiv.querySelector('table');
        if (table) {
            var rows = table.rows;
            for (var i = 0; i < rows.length; i++) {
                var cells = rows[i].cells;
                for (var j = 0; j < cells.length; j++) {
                    output += cells[j].textContent.trim() + '\t'; // Use tab for spacing between columns
                }
                output += '\n'; // New line for each row
            }
            output += '\n'; // Extra line break after the table
        } else {
            console.error('No table found in the HTML string');
        }
    
        // Extract subtotal, discount, tax, grand total from the table below
        var rows = tempDiv.querySelectorAll('tr'); // Get all table rows
        rows.forEach(function (row) {
            var cells = row.cells;
            if (cells.length === 2) {
                var label = cells[0].textContent.trim();
                var value = cells[1].textContent.trim();
                if (label === 'Subtotal') {
                    output += 'Subtotal: ' + value + '\n';
                } else if (label.startsWith('Discount')) {
                    output += label + ': ' + value + '\n'; // Handles 'Discount (X%)'
                } else if (label === 'Grand Total') {
                    output += 'Grand Total: ' + value + '\n';
                }
            }
        });
    
        // Extract footer message
        var footer = tempDiv.querySelector('div[style*="text-align: center"]');
        output += '\n' + (footer ? footer.textContent.trim() : '') + '\n';
    
        return output;
    }
    
    useEffect(() => {
        console.log(printInvoice)
        if (printInvoice == true) {
            showPrintLoader({printLoader: true})
            printBillIframe(branchData, businessTempData)
            setPrintInvoice({printInvoice: false})
        }
    }, [printInvoice])
    return (
        <>
            <iframe id="myIframe" style={{display: 'none'}}></iframe> 
        </>
    );
};

const mapStateToProps = ({ data, auth }) => {
    const {
        businessData,
        invoiceWithOrders,
        paymentStatus,
        printInvoice,
        bluetoothStatus,
        defaultPrinterName
    } = data
    const {
        authToken,
        buildType
    } = auth
    return {
        businessData,
        authToken,
        invoiceWithOrders,
        paymentStatus,
        printInvoice,
        bluetoothStatus,
        defaultPrinterName,
        buildType
    }
}
  
const mapDispatchToProps = {
    setPrintInvoice,
    setDefaultPrinterName,
    showPrinterSettingModal,
    showPrintLoader
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintBill);